
export enum enumHotCardSex {
  Male = 1,
  Female,
  'N/A'
}

export namespace enumHotCardSex {
  export function values() {
    return Object.keys(enumHotCardSex).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}

